import React, { useState, useRef } from 'react'
import { Input, Button, Toast, Dialog } from 'antd-mobile'
import DpBusinessPopup from '../DpBusinessComponents/DpBusinessPopup'
import { getValue } from '@/libs/functions/getValue'

import styles from './index.scss'

interface EquityActivateProps {
  style?: React.CSSProperties
  children: React.ReactElement
  equityExpirationEndText?: string
  showEquityExpirationEndText?: boolean
  isNeedRealName?: boolean | (() => boolean)
  activeParams?: Record<string, any>
  onReload?: () => void
  bindFunc?: (params?: any) => void
  activeFunc?: (params?: any) => void
  handleBind?: (value: string, callback: () => void) => void
  realNameFunc?: () => void
}

const index: React.FC<EquityActivateProps> = ({
  style,
  children,
  equityExpirationEndText,
  showEquityExpirationEndText = true,
  isNeedRealName,
  activeParams,
  onReload,
  activeFunc,
  handleBind,
  realNameFunc,
}) => {
  const couponStatus: any = getValue('couponStatus')
  const [visible, setVisible] = useState(false)
  const inputValue = useRef('')
  const setInputVallue = (val: string) => {
    inputValue.current = val
  }

  const onOpen = () => {
    if (
      typeof isNeedRealName === 'boolean' ? isNeedRealName : isNeedRealName?.()
    ) {
      realNameFunc ? realNameFunc() : setVisible(true)
      return
    }
    Dialog.show({
      title: '权益激活',
      content: (
        showEquityExpirationEndText ? (
          <div className={styles.userdialog}>
            <div className={styles.tip}>{equityExpirationEndText}</div>
          </div>
        ): <></>
      ),
      actions: [
        [
          {
            key: 'cancel',
            text: '取消',
            onClick: Dialog.clear,
            style: {
              color: '#202020',
              fontSize: 15,
            },
          },
          {
            key: 'delete',
            text: '确定激活',
            onClick: handleActive,
            style: { fontSize: 15 },
            className: styles['active-btn'],
          },
        ],
      ],
    })
  }

  const handleActive = () => {
    activeFunc?.(activeParams)?.then(() => {
      Toast.show({
        content: '激活成功',
        position: 'center',
      })
      Dialog.clear()
      onReload?.()
    })
  }

  return (
    <>
      <children.type key={children.key} {...children.props} onClick={onOpen} />
      <DpBusinessPopup
        title="权益激活"
        headerStyle={{ textAlign: 'center' }}
        bodyStyle={style}
        popupBodyStyles={{ minHeight: 0 }}
        visible={visible}
        onClose={() => setVisible(false)}
      >
        <div className={styles.label}>实名绑定</div>
        <Input
          className={styles.input}
          defaultValue={couponStatus.userName || ''}
          placeholder="请输入使用人姓名"
          onChange={setInputVallue}
        />
        <p className={styles.tips}>
          *本权益限制实名使用，权益一经绑定，不可更改
        </p>
        {showEquityExpirationEndText && (
          <p className={styles.tips}>*{equityExpirationEndText}</p>
        )}
        <Button
          block
          className={styles.button}
          onClick={() =>
            handleBind?.(inputValue.current, () => setVisible(false))
          }
        >
          确定激活
        </Button>
      </DpBusinessPopup>
    </>
  )
}

export default index
